import { Card, Form, Accordion, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface ISurveyAccordionRowProps {
  survey: ISurvey;
  isSelected: boolean;
  handleSelectedSurvey: any;
  dataTestId?: string;
}

const SurveyAccordionRow = ({
  survey,
  isSelected,
  handleSelectedSurvey,
  dataTestId
}: ISurveyAccordionRowProps) => {
  const intl = useIntl();

  const questions: IQuestion[] = [];
  for (const page of survey.pages) {
    questions.push(...page.questions);
  }
  const questionsWithTitle = questions.filter((question) => question.title);

  return (
    <Card className="surveyAccordionRow w-100">
      <Accordion.Item eventKey={survey.survey_id} className="d-flex flex-row border-none">
        <Form.Check
          data-test={dataTestId}
          type="radio"
          className="py-3 ps-3"
          id={survey.survey_id}
          checked={isSelected}
          onChange={() =>
            handleSelectedSurvey(isSelected ? 'remove' : 'add', survey.title, survey.survey_id)
          }
        />
        <div className="w-100">
          <Accordion.Header>
            <OverlayTrigger
              overlay={
                <Tooltip id="questionnaire-title" data-test="questionnaire-title-tooltip">
                  {intl.formatMessage({ id: survey.title })}
                </Tooltip>
              }
            >
              <span className="pe-4 white-space-nowrap text-overflow-ellipsis overflow-hidden">
                {intl.formatMessage({ id: survey.title })}
              </span>
            </OverlayTrigger>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Body>
              <ListGroup variant="flush">
                {questionsWithTitle.map((question, index) => (
                  <ListGroup.Item
                    data-test={`answer-survey-${survey.survey_id}-question-${index}`}
                    key={question.question_id}
                  >
                    {question.title && intl.formatMessage({ id: question.title })}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card.Body>
          </Accordion.Body>
        </div>
      </Accordion.Item>
    </Card>
  );
};

export default SurveyAccordionRow;
